import React, {Fragment} from 'react'
import {Link} from 'react-router-dom'
import {formatDate, formatNumber} from 'admin/lib/format'
import useModal from 'admin/hooks/useModal'

export default ({data, organisationId, SelectAll, SelectOne, children}) => {
  const {pushModal} = useModal()

  return (
    <Fragment>
      {children}
      <table className='table is-striped is-hoverable is-fullwidth is-linked is-payments'>
        <colgroup>
          <col width='2%' />
          <col width='13%' />
          <col width='auto' />
          <col width='auto' />
          <col width='auto' />
          <col width='auto' />
          <col width='13%' />
          <col width='20%' />
        </colgroup>
        <thead>
          <tr>
            <th>
              <SelectAll />
            </th>
            <th>Date received</th>
            <th>Details</th>
            <th>Particulars</th>
            <th>Code</th>
            <th>Reference</th>
            <th className='has-text-right'>Amount</th>
            <th>Account</th>
          </tr>
        </thead>

        <tbody>
          {data.map((payment, i) => {
            return (
              <tr
                key={i}
                onClick={e => {
                  if (
                    e.target.tagName.toLowerCase() !== 'button' &&
                    e.target.tagName.toLowerCase() !== 'a' &&
                    e.target.type !== 'checkbox'
                  ) {
                    e.preventDefault()
                    pushModal('payment', {accountId: payment.account?.id, paymentId: payment.id})
                  }
                }}>
                <td>
                  <SelectOne identifier={payment.id} />
                </td>
                <th>{formatDate(payment.date)}</th>
                <td>{payment.importDetails}</td>
                <td>{payment.importParticulars}</td>
                <td>{payment.importCode}</td>
                <td>{payment.importReference}</td>
                <th className='has-text-right'>{formatNumber(payment.amount)}</th>
                <td>
                  <div className='is-flex is-justify-content-space-between'>
                    <div>
                      <Link to={`/orgs/${organisationId}/accounts/${payment.account?.id}`}>
                        {payment.account?.displayName}
                      </Link>
                      {payment.account && payment.account.displayName !== payment.account.contactFullName ? (
                        <sub style={{whiteSpace: 'pre-line'}}>{payment.account?.contactFullName}</sub>
                      ) : null}
                    </div>
                    <div className='ml-1'>
                      {payment.xeroLink && (
                        <span className='tag is-small has-text-white' style={{backgroundColor: '#51afd8'}}>
                          X
                        </span>
                      )}
                      {payment.isDuplicate && <span className='tag is-small is-danger'>D</span>}
                    </div>
                  </div>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </Fragment>
  )
}
